import { Stack, Typography } from '@mui/material';
import { Sidebar, Snackbar } from 'app/components';
import { useEnv } from 'app/services';
import React from 'react';

const ContentLayout = (props) => {
  const { children } = props;
  const { MODE: mode } = useEnv();

  return (
    <Stack direction='column' sx={{ height: '100%' }}>
      <Stack
        direction='row'
        sx={{
          height: '100%',
          paddingBottom: mode === 'secondary' ? '30px' : 0,
          position: 'relative',
        }}>
        <Sidebar />
        <Stack
          direction='column'
          sx={{
            flex: '1',
            height: '100%',
          }}>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='center'
            sx={{
              position: 'relative',
              flex: '1',
              overflow: 'hidden',
            }}>
            {children}
          </Stack>
        </Stack>
        <Snackbar />
      </Stack>
      {mode === 'secondary' && (
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          sx={(theme) => ({
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '100%',
            height: '30px',
            zIndex: 9999,
            padding: theme.spacing(0, 2),
            bgcolor: theme.palette.warning.main,
          })}>
          <Typography variant='body2'>Приложение работает в ограниченном режиме, некоторые разделы и функции недоступны.</Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default ContentLayout;
